import { TransactionStatus } from '../../../../typings/transaction';

export const PAGE_SIZE_MOBILE = 10;
export const PAGE_SIZE_DESKTOP = 30;

export const TAB_TYPE_BUYING = 'purchases';
export const TAB_TYPE_SELLING = 'sales';
export const TAB_TYPE_VERIFICATION = 'verification';
export const TAB_TYPE_CLAIMS_AND_RETURNS = 'returns';
export const TAB_SELLING_ID = 0;
export const TAB_BUYING_ID = 1;
export const TAB_VERIFICATION_ID = 2;

export type Tab =
  | typeof TAB_TYPE_SELLING
  | typeof TAB_TYPE_BUYING
  | typeof TAB_TYPE_CLAIMS_AND_RETURNS
  | typeof TAB_TYPE_VERIFICATION;

export type Tabs = [
  typeof TAB_TYPE_SELLING,
  typeof TAB_TYPE_BUYING,
  typeof TAB_TYPE_CLAIMS_AND_RETURNS,
  typeof TAB_TYPE_VERIFICATION,
];

export type TransactionTab = typeof TAB_TYPE_SELLING | typeof TAB_TYPE_BUYING;
export const transactionTabs = [TAB_TYPE_SELLING, TAB_TYPE_BUYING];

export const VALIDATE_BUTTON = 'VALIDATE_BUTTON';
export const TRACKING_NUMBER = 'TRACKING_NUMBER';
export const DELIVERY_ADDRESS = 'DELIVERY_ADDRESS';

export type Section = typeof VALIDATE_BUTTON | typeof TRACKING_NUMBER | typeof DELIVERY_ADDRESS;

export type SectionVisibility = Record<TransactionStatus, Partial<Record<Section, boolean>>>;

export enum USER_TYPE {
  SELLER = 'seller',
  BUYER = 'buyer',
}

export const SERVICE_FEE_PRICE = 'service-fee-price';

export const EXTERNAL_LINKS = {
  CREATE_REQUEST: 'https://pomoc.olx.pl/olxplhelp/s/contactsupport',
  SAFE_DEAL_TERMS:
    'https://pomoc.olx.pl/olxplhelp/s/article/kA009000001v2JhCAI',
  SAFE_DEAL_TERMS_V20:
    'https://pomoc.olx.pl/olxplhelp/s/article/za%C5%82%C4%85cznik-nr-8-pakiet-ochronny-olx-V20-olx',
  READ_MORE_ABOUT_RETURNS: 'https://pomoc.olx.pl/olxplhelp/s/article/kA009000001v2JhCAI',
};

export const SECTION_VISIBILITY: SectionVisibility = {
  ORDER_REJECTED: {
    VALIDATE_BUTTON: true,
    TRACKING_NUMBER: true,
    DELIVERY_ADDRESS: true,
  },
  ORDER_EXPIRED: {
    VALIDATE_BUTTON: false,
    TRACKING_NUMBER: true,
    DELIVERY_ADDRESS: true,
  },
  CONTRACT_REQUESTED: {
    VALIDATE_BUTTON: true,
    TRACKING_NUMBER: false,
    DELIVERY_ADDRESS: true,
  },
  KYC_RETRY_NEEDED_CONFIRMATION: {
    VALIDATE_BUTTON: true,
    TRACKING_NUMBER: false,
    DELIVERY_ADDRESS: true,
  },
  CONTRACT_CREATED: {
    VALIDATE_BUTTON: true,
    TRACKING_NUMBER: true,
    DELIVERY_ADDRESS: true,
  },
  PACKAGE_POSTED: {
    VALIDATE_BUTTON: true,
    TRACKING_NUMBER: true,
    DELIVERY_ADDRESS: true,
  },
  PACKAGE_IN_TRANSIT: {
    VALIDATE_BUTTON: true,
    TRACKING_NUMBER: true,
    DELIVERY_ADDRESS: true,
  },
  PACKAGE_READY_TO_PICKUP: {
    VALIDATE_BUTTON: true,
    TRACKING_NUMBER: true,
    DELIVERY_ADDRESS: true,
  },
  PACKAGE_DELIVERED: {
    VALIDATE_BUTTON: true,
    TRACKING_NUMBER: true,
    DELIVERY_ADDRESS: true,
  },
  PACKAGE_REJECTED: {
    VALIDATE_BUTTON: true,
    TRACKING_NUMBER: true,
    DELIVERY_ADDRESS: true,
  },
  PACKAGE_PICKUP_EXPIRED: {},
  SHIPMENT_LABEL_RECEIVED: {
    VALIDATE_BUTTON: false,
    TRACKING_NUMBER: true,
    DELIVERY_ADDRESS: true,
  },
  CONTRACT_CANCELLED: {
    VALIDATE_BUTTON: true,
    TRACKING_NUMBER: true,
    DELIVERY_ADDRESS: true,
  },
  PAYOUT_PENDING: {
    VALIDATE_BUTTON: true,
    TRACKING_NUMBER: true,
    DELIVERY_ADDRESS: true,
  },
  PAYOUT_FAILED: {
    VALIDATE_BUTTON: false,
    TRACKING_NUMBER: true,
    DELIVERY_ADDRESS: true,
  },
  PAYOUT_SENT: {
    VALIDATE_BUTTON: true,
    TRACKING_NUMBER: true,
    DELIVERY_ADDRESS: true,
  },
  KYC_RETRY_NEEDED_PAYOUT: {
    VALIDATE_BUTTON: true,
    TRACKING_NUMBER: true,
    DELIVERY_ADDRESS: true,
  },
  REFUND_REQUESTED: {
    VALIDATE_BUTTON: false,
    TRACKING_NUMBER: true,
    DELIVERY_ADDRESS: true,
  },
  REFUND_SENT: {
    VALIDATE_BUTTON: false,
    TRACKING_NUMBER: true,
    DELIVERY_ADDRESS: true,
  },
  REFUND_FAILED: {
    VALIDATE_BUTTON: false,
    TRACKING_NUMBER: true,
    DELIVERY_ADDRESS: true,
  },
  KYC_VERIFICATION_PENDING: {
    VALIDATE_BUTTON: false,
    TRACKING_NUMBER: false,
    DELIVERY_ADDRESS: true,
  },
  CONTRACT_EXPIRED: {
    VALIDATE_BUTTON: false,
    TRACKING_NUMBER: false,
    DELIVERY_ADDRESS: true,
  },
  SHIPMENT_EXPIRED: {
    VALIDATE_BUTTON: false,
    TRACKING_NUMBER: false,
    DELIVERY_ADDRESS: true,
  },
  SHIPMENT_ERROR: {
    VALIDATE_BUTTON: true,
    TRACKING_NUMBER: true,
    DELIVERY_ADDRESS: true,
  },
  PAYOUT_REQUESTED: {
    VALIDATE_BUTTON: false,
    TRACKING_NUMBER: true,
    DELIVERY_ADDRESS: true,
  },
  SAFEDEAL_ACCEPTED_BY_BUYER: {},
  SAFEDEAL_BUYER_ACCEPTANCE_EXPIRED: {},
  SAFEDEAL_REJECTED_BY_BUYER: {},
  SAFEDEAL_CS_PAYOUT_REQUESTED: {},
  SAFEDEAL_CS_FULL_REFUND_REQUESTED: {},
  SAFEDEAL_CS_DECISION_EXPIRED: {},
  SAFEDEAL_CS_RETURN_INITIATED: {},
  ORDER_CREATED: {},
  DELIVERED_ITEM_REJECTED: {},
};

export const SD_ASTERISK_MODAL_TRANSLATIONS = {
  link: 'dlv_insurance_fee_read_terms_exclusions_link',
  description: 'dlv_orders_insurance_fee_asterisk_note',
};

export const SELLER_TAKE_RATE = 'seller-take-rate-price';
